import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["CountUp"] */ "/app/src/app/(home)/components/count-up.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(home)/components/footer.tsx");
